import getPageName from "./getPageName";

/* Скрипты AdvCake при загрузке страницы */
export const advcakeScriptFromPage = () => {
    if (getPageName() == '') {
        window.advcake_data = window.advcake_data || [];
        window.advcake_data.push({
            pageType: 1,
        });
    } else {
        window.advcake_data = window.advcake_data || [];
        window.advcake_data.push({
            pageType: 2,
        });
    }
}

/* Скрипты AdvCake после отправки формы */
export const advcakeScriptSendForm = (id, leadid, program, email) => {
    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
        pageType: 6,
            user: {
                email: `md5(${email})`,
                type: ''
            },
        leadInfo: {
            id: `${id}`, // id приходит нам из гермеса полсе отправки формы
            leadid: `${leadid}`, // id программы (program_group_id)
            name: `${program}`,
            totalPrice: 0,
            coupon: ''
        }
    });
}